import classNames from 'classnames';
import { css, styled } from 'css-literal-loader/styled';
import React from 'react';
import BaseDropdown from 'react-overlays/Dropdown';
import withProps from 'recompose/withProps';

import DropdownMenu from './DropdownMenu';
import DropdownToggle from './DropdownToggle';

const styles = require('./Dropdown-styles.module.scss');

// eslint-disable-next-line react/prefer-stateless-function
class Dropdown extends React.Component {
  render() {
    const {
      children,
      drop,
      alignEnd,
      onToggle,
      show,
      id,
      flip = false,
      title,
      className,
    } = this.props;
    return (
      <BaseDropdown
        show={show}
        drop={drop}
        flip={flip}
        onToggle={onToggle}
        alignEnd={alignEnd}
        itemSelector="* > button"
      >
        {({ props }) => (
          <span {...props} className={classNames(className, styles.dropdown)}>
            <DropdownToggle id={id}>{title}</DropdownToggle>
            <DropdownMenu>{children}</DropdownMenu>
          </span>
        )}
      </BaseDropdown>
    );
  }
}

const DropdownItem = withProps(p => ({
  role: 'menuitem',
  autoFocus: !!p.active,
  'data-selected': !!p.active,
}))(
  styled('button', null, "DropdownItem", require("./Dropdown-DropdownItem.module.scss"), "dropdown-item", "dropdownItem"),
);

Dropdown.Item = DropdownItem;

export default Dropdown;
